import React, { useState, useEffect, useCallback, useRef } from "react";
import { InputLabelAlert, InputAlert } from "../../../layout";
import {
  mCPF,
  getCookie,
  mDate,
  mTel,
  formatFloat,
  formatCurrency,
  Aguarde,
} from "../../../../helpers/general";
import {
  validateCPF,
  validateDate,
  validateEmail,
} from "../../../../helpers/validation";
import {
  sendData,
  sendMultiPartData,
  setSession,
} from "../../../../helpers/auth";
import { uriList } from "../../../../helpers/config";
import { connect } from "react-redux";
import {
  setProposta,
  setClienteDados,
  setCliente,
  setSimulacao,
  setAlterarProposta,
} from "../../../../store/actions/dados";
import { swalError, confirmSwal } from "../../../swal";
import { Modal, Spinner } from "react-bootstrap";
import { Button } from "reactstrap";
import Simulacao from "./Simulacao";
import ResumoSimulacao from "./ResumoSimulacao";
import * as moment from "moment";

const dataIni = { cpf: "", nome: "", ddn: "", telefone: "", email: "" };
function CreditoTrabalhador({ ...props }) {
  const [warning, setWarning] = useState({});
  const [consultando, setConsultando] = useState(false);
  const [dados, setDados] = useState(dataIni);
  const [vinculos, setVinculos] = useState(null);
  const [contas, setContas] = useState(null);
  const [vinculoSelecionado, setVinculoSelecionado] = useState(null);
  const [contaSelecionada, setContaSelecionada] = useState(null);
  const [proposta, setProposta] = useState({});
  const [show, setShow] = useState(false);
  const [gravando, setGravando] = useState(false);
  const [legendaGravando, setLegendaGravando] = useState("");
  const [clienteExistente, setClienteExistente] = useState(false);
  const [aguardandoAvaliacao, setAguardandoAvaliacao] = useState(false);
  const [limites, setLimites] = useState(null);
  const [avaliacaoDeRisco, setAvaliacaoDeRisco] = useState(null);
  const [parametrosVinculo, setParametrosVinculo] = useState(null);
  const [simulacaoCTrab, setSimulacaoCTrab] = useState(null);

  // useRef para armazenar a função de consulta sem causar re-renders
  const consultarAvaliacaoRiscoCTrabRef = useRef(null);

  // Função para consultar avaliação de risco
  const consultarAvaliacaoRiscoCTrab = useCallback(async (params = {}) => {
    const {
      cpf: _cpf = dados.cpf,
      proposta_uuid: _proposta_uuid = proposta.uuid || proposta.proposta_uuid,
      contaSelecionada: _contaSelecionada = contaSelecionada,
      vinculoSelecionado: _vinculoSelecionado = vinculoSelecionado,
      idSolicitacao: _idSolicitacao = null,
    } = params;

    // Determinar o idSolicitacao: priorizar o passado por parâmetro, senão buscar do estado
    const idSolicitacaoFinal = _idSolicitacao ||
      avaliacaoDeRisco?.response?.idSolicitacao ||
      avaliacaoDeRisco?.idSolicitacao ||
      null;

    console.log("CreditoTrabalhador.consultarAvaliacaoRiscoCTrab", {
      cpf: _cpf,
      proposta_uuid: _proposta_uuid,
      contaSelecionada: _contaSelecionada,
      vinculoSelecionado: _vinculoSelecionado,
      idSolicitacao: idSolicitacaoFinal,
      avaliacaoDeRisco: avaliacaoDeRisco,
    });

    await sendData({
      uri: uriList("consultarAvaliacaoRiscoCTrab"),
      content: {
        cpf: _cpf.replace(/\D/g, ''),
        proposta_uuid: _proposta_uuid,
        contaSelecionada: _contaSelecionada,
        vinculoSelecionado: _vinculoSelecionado,
        idSolicitacao: idSolicitacaoFinal,
      },
      method: "POST",
    })
      .then((res) => {
        console.log("CreditoTrabalhador.consultarAvaliacaoRiscoCTrab - res: ", res);
        if (res?.status && parseInt(res?.status) > 200) throw new Error();

        // Se a avaliação foi concluída (status 200), parar o polling e exibir simulação
        if (res?.status === 200 || (!res?.status && (res?.data?.status === 'concluida' || res?.data?.avaliacao))) {
          setAguardandoAvaliacao(false);

          // Guardar os limites retornados pela API
          if (res?.data?.limites) {
            setLimites(res.data.limites);
          }

          // Atualizar proposta se necessário
          if (res?.data?.proposta) {
            props.alterarProposta(res.data.proposta);
          }

          // Exibir modal de simulação
          setShow(true);
        }
      })
      .catch((e) => {
        console.log("CreditoTrabalhador.consultarAvaliacaoRiscoCTrab - erro: ", e);
      });
  }, [dados.cpf, proposta.uuid, proposta.proposta_uuid, contaSelecionada, vinculoSelecionado, avaliacaoDeRisco, props]);

  // Atualizar a ref sempre que a função mudar
  useEffect(() => {
    consultarAvaliacaoRiscoCTrabRef.current = consultarAvaliacaoRiscoCTrab;
  }, [consultarAvaliacaoRiscoCTrab]);

  // useEffect para gerenciar a consulta automática
  useEffect(() => {
    if (aguardandoAvaliacao) {
      console.log("CreditoTrabalhador - Iniciando polling automático");

      // Iniciar a consulta automática a cada 20 segundos
      const consultaInterval = setInterval(() => {
        console.log("CreditoTrabalhador - Executando consulta automática");
        // Usar a ref para chamar a versão mais recente da função
        if (consultarAvaliacaoRiscoCTrabRef.current) {
          consultarAvaliacaoRiscoCTrabRef.current();
        }
      }, 20000);

      // Cleanup ao desmontar ou quando aguardandoAvaliacao mudar para false
      return () => {
        console.log("CreditoTrabalhador - Parando polling automático");
        clearInterval(consultaInterval);
      };
    }
  }, [aguardandoAvaliacao]);

  const validarDados = () => {
    let result = true;
    let _warning = {};

    if (!dados.cpf || !validateCPF(dados.cpf)) {
      _warning = { ..._warning, cpf: 1 };
      result = false;
    }

    console.log("CreditoTrabalhador.validarDados", _warning);
    setWarning(_warning);
    return result;
  };

  const carregarDados = async (cpf) => {
    console.log("CreditoTrabalhador.carregarDados", cpf);
    if (!cpf) return;

    await sendData({
      uri: uriList("pessoa"),
      content: { cpf },
      signal: null,
      method: "POST",
    })
      .then(async (res) => {
        console.log("CreditoTrabalhador - carregarDados - res: ", res);
        if (res.status && res.status > 200) throw new Error(res.message);

        // Gravar cliente no Redux
        props.alterarCliente(res.data.id);
        props.setClienteDados(res.data);

        // Atualizar dados do formulário
        setDados({
          ...dados,
          cpf,
          nome: res?.data?.nome || "",
          ddn: res?.data?.ddn ? moment(res?.data?.ddn).format("DD/MM/YYYY") : "",
          telefone: mTel(res?.data?.telefone || res?.data?.celular || ""),
          email: res?.data?.email || "",
        });
        setClienteExistente(true);

        // Verificar se existe proposta em andamento
        await verificarPropostaEmAndamento(cpf, res.data);
      })
      .catch((e) => {
        console.log("CreditoTrabalhador - carregarDados - error: ", e);
        // Em caso de erro, manter o CPF mas limpar os outros campos
        setDados({ ...dataIni, cpf });
      });
  };

  const verificarPropostaEmAndamento = async (cpf, clienteData) => {
    console.log("CreditoTrabalhador.verificarPropostaEmAndamento(1)", cpf);

    await sendData({
      uri: uriList("verificarPropostaCTrabEmAndamento"),
      content: { cpf: cpf.replace(/\D/g, '') },
      method: "POST",
    })
      .then((res) => {
        console.log("CreditoTrabalhador.verificarPropostaEmAndamento(2) - res: ", res);
        if (res?.status && parseInt(res?.status) > 200) return;
        if (!res?.data) return;

        const propostaEmAndamento = res.data;
        const creditoTrabalhador = propostaEmAndamento.creditotrabalhador;
        console.log("CreditoTrabalhador.verificarPropostaEmAndamento(3) - creditoTrabalhador: ", { propostaEmAndamento, creditoTrabalhador });

        // Se não tem creditoTrabalhador, não há nada para restaurar
        if (!creditoTrabalhador) return;

        let etapaRestaurada = "";
        let vinculosElegiveis = null;
        let vinculoSelecionadoRestaurado = null;
        let contasRestauradas = null;
        let contaSelecionadaRestaurada = null;
        let parametrosVinculoRestaurado = null;

        // 1. Verificar se tem vínculos salvos
        if (creditoTrabalhador.vinculos?.response?.vinculos) {
          console.log("CreditoTrabalhador.verificarPropostaEmAndamento(4) - vinculos: ", creditoTrabalhador.vinculos.response.vinculos);
          vinculosElegiveis = creditoTrabalhador.vinculos.response.vinculos.filter(
            (v) => v.elegivelEmprestimo === true
          );
          etapaRestaurada = "Seleção de Vínculos";

          // 2. Verificar se tem vínculo selecionado
          // Priorizar o payload de solicitarAvaliacaoRisco, depois contas, depois parametrosVinculo
          if (creditoTrabalhador.solicitarAvaliacaoRisco?.payload?.vinculoSelecionado) {
            vinculoSelecionadoRestaurado = creditoTrabalhador.solicitarAvaliacaoRisco.payload.vinculoSelecionado;
          } else if (creditoTrabalhador.contas?.payload?.vinculoSelecionado) {
            vinculoSelecionadoRestaurado = creditoTrabalhador.contas.payload.vinculoSelecionado;
          } else if (creditoTrabalhador.parametrosVinculo?.payload?.vinculoSelecionado ||
            creditoTrabalhador.parametrosVinculo?.payload?.idVinculo) {
            vinculoSelecionadoRestaurado = creditoTrabalhador.parametrosVinculo.payload.vinculoSelecionado ||
              creditoTrabalhador.parametrosVinculo.payload.idVinculo;
          }

          if (vinculoSelecionadoRestaurado) {
            etapaRestaurada = "Vínculo Selecionado";

            // 3. Verificar se tem parâmetros de vínculo
            if (creditoTrabalhador.parametrosVinculo?.response) {
              parametrosVinculoRestaurado = creditoTrabalhador.parametrosVinculo.response;
            }

            // 4. Verificar se tem contas
            if (creditoTrabalhador.contas?.response && Array.isArray(creditoTrabalhador.contas.response)) {
              contasRestauradas = creditoTrabalhador.contas.response;
              etapaRestaurada = "Seleção de Contas";

              // 4. Verificar se tem conta selecionada
              if (creditoTrabalhador.solicitarAvaliacaoRisco?.payload?.contaSelecionada) {
                contaSelecionadaRestaurada = creditoTrabalhador.solicitarAvaliacaoRisco.payload.contaSelecionada;
              } else if (creditoTrabalhador.contas?.payload?.contaSelecionada) {
                contaSelecionadaRestaurada = creditoTrabalhador.contas.payload.contaSelecionada;
              }

              if (contaSelecionadaRestaurada) {
                etapaRestaurada = "Conta Selecionada";

                // 5. Verificar se tem solicitação de avaliação de risco
                if (creditoTrabalhador.solicitarAvaliacaoRisco?.response) {
                  // Se tem idSolicitacao e situação = 1 (aguardando)
                  if (creditoTrabalhador.solicitarAvaliacaoRisco.response.idSolicitacao &&
                    creditoTrabalhador.solicitarAvaliacaoRisco.response.icSituacaoSolicitacao === 1) {
                    etapaRestaurada = "Aguardando Avaliação de Risco";
                  }
                  // Se já tem limites/codigoAvaliacaoTomador, avaliação concluída
                  else if (creditoTrabalhador.solicitarAvaliacaoRisco.response.codigoAvaliacaoTomador) {
                    if (creditoTrabalhador.avaliacaoRisco?.response?.limites) {
                      etapaRestaurada = "Avaliação Concluída - Pronto para Simulação";
                    } else {
                      etapaRestaurada = "Avaliação Concluída - Consultando limites";
                    }
                  }
                }
              }
            }
          }
        }

        // Exibir mensagem de confirmação se alguma etapa foi encontrada
        if (etapaRestaurada) {
          confirmSwal({
            title: "Proposta em Andamento",
            text: `Foi encontrada uma proposta em andamento para este CPF. Etapa: ${etapaRestaurada}, deseja continuar com essa proposta?`,
            icon: "info",
            callback: (confirmado) => {
              // Só restaurar o estado se o usuário confirmar (true = Sim, null = Não)
              if (confirmado) {
                console.log("CreditoTrabalhador.verificarPropostaEmAndamento - Usuário confirmou, restaurando estado");

                // Restaurar proposta
                setProposta(propostaEmAndamento);

                // Restaurar vínculos
                if (vinculosElegiveis) {
                  setVinculos(vinculosElegiveis);
                }

                // Restaurar vínculo selecionado
                if (vinculoSelecionadoRestaurado) {
                  setVinculoSelecionado(vinculoSelecionadoRestaurado);
                }

                // Restaurar parâmetros de vínculo
                if (parametrosVinculoRestaurado) {
                  setParametrosVinculo(parametrosVinculoRestaurado);
                }

                // Restaurar contas
                if (contasRestauradas) {
                  setContas(contasRestauradas);
                }

                // Restaurar conta selecionada
                if (contaSelecionadaRestaurada) {
                  setContaSelecionada(contaSelecionadaRestaurada);
                }

                // Restaurar avaliação de risco e ações relacionadas
                console.log("CreditoTrabalhador.verificarPropostaEmAndamento - creditoTrabalhador.solicitarAvaliacaoRisco: ", { solicitarAvaliacaoRisco: creditoTrabalhador.solicitarAvaliacaoRisco, creditoTrabalhador });
                if (creditoTrabalhador.solicitarAvaliacaoRisco?.response) {
                  setAvaliacaoDeRisco(creditoTrabalhador.solicitarAvaliacaoRisco);

                  const cpfRestaurado = clienteData?.cpf || dados.cpf;
                  const idSolicitacaoRestaurado = creditoTrabalhador.solicitarAvaliacaoRisco.response.idSolicitacao;

                  const parametrosConsulta = {
                    cpf: cpfRestaurado,
                    proposta_uuid: propostaEmAndamento.uuid || propostaEmAndamento.proposta_uuid,
                    contaSelecionada: contaSelecionadaRestaurada,
                    vinculoSelecionado: vinculoSelecionadoRestaurado,
                    idSolicitacao: idSolicitacaoRestaurado,
                  };

                  console.log("CreditoTrabalhador - Parâmetros para consulta:", parametrosConsulta);

                  // Verificar se já tem limites salvos - se sim, abrir simulação diretamente
                  if (creditoTrabalhador.avaliacaoRisco?.response?.limites) {
                    console.log("CreditoTrabalhador - Limites já disponíveis, abrindo simulação");
                    setLimites(creditoTrabalhador.avaliacaoRisco.response.limites);
                    // Abrir modal de simulação automaticamente após um pequeno delay
                    setTimeout(() => {
                      setShow(true);
                    }, 1500);
                  }
                  // Se não tem limites mas tem solicitação de avaliação, consultar automaticamente
                  else {
                    console.log("CreditoTrabalhador - Solicitação de avaliação encontrada, consultando status");

                    // Se está aguardando avaliação (icSituacaoSolicitacao === 1), ativar banner
                    if (creditoTrabalhador.solicitarAvaliacaoRisco.response.idSolicitacao &&
                      creditoTrabalhador.solicitarAvaliacaoRisco.response.icSituacaoSolicitacao === 1) {
                      setAguardandoAvaliacao(true);
                    }

                    // SEMPRE chamar a consulta quando tiver solicitação de avaliação sem limites
                    setTimeout(() => {
                      consultarAvaliacaoRiscoCTrab(parametrosConsulta);
                    }, 1000);
                  }
                }
              } else {
                console.log("CreditoTrabalhador.verificarPropostaEmAndamento - Usuário cancelou, mantendo estado atual");
              }
            }
          });
        }
      })
      .catch((e) => {
        console.log("CreditoTrabalhador.verificarPropostaEmAndamento - erro: ", e);
      });
  };

  const handleCpf = (e) => {
    setWarning({ ...warning, cpf: 0 });
    let nums = /\d/;
    let cpf = e.currentTarget.value;

    if (nums.test(e.currentTarget.value)) {
      cpf = mCPF(e.currentTarget.value);
      setDados({ ...dados, cpf });

      if (cpf?.length >= 14) {
        let valid = validateCPF(cpf);
        if (!valid) {
          setWarning({ ...warning, cpf: 1 });
        } else {
          carregarDados(cpf);
        }
      }

      return false;
    } else if (!e.currentTarget.value) {
      setDados({ ...dados, cpf: "" });
    }

    return false;
  };

  const handleChange = (e) => {
    setWarning({ ...warning, [e.target.name]: 0 });
    let target = e.currentTarget;
    let name = target.name;
    let value = target.value;

    if (name === "ddn") {
      setDados({ ...dados, [name]: mDate(value) });
    } else if (name === "telefone") {
      setDados({ ...dados, [name]: mTel(value) });
    } else if (name === "email") {
      setDados({ ...dados, [name]: value.toLowerCase() });
    } else {
      setDados({ ...dados, [name]: value });
    }
  };

  const handleBlur = (e) => {
    let target = e.currentTarget;
    let name = target.name;
    let valor = target.value;
    setWarning({ ...warning, [name]: 0 });

    if (name === "ddn" && valor) {
      if (!validateDate(valor)) setWarning({ ...warning, [name]: 1 });
    } else if (name === "cpf" && valor) {
      if (!validateCPF(valor)) setWarning({ ...warning, [name]: 1 });
    } else if (name === "email" && valor) {
      if (!validateEmail(valor)) setWarning({ ...warning, [name]: 1 });
    }
  };

  // const handleSimulation = async (_simulacao) => {
  //   console.log("handleSimulation", _simulacao);
  //   setGravando(true);
  //   dados.agente_id =
  //     ["AGENTE", "OPERADOR PARCEIRO"].indexOf(props.user?.tipo) >= 0
  //       ? props.user?.pessoa_id
  //       : null;
  //   dados.operador_id = props.user?.pessoa_id;
  //   await sendData({
  //     uri: uriList("gravarPropostaCreditoTrabalhador"),
  //     content: { dados, simulacoes: _simulacao },
  //     method: "POST",
  //   })
  //     .then((res) => {
  //       setGravando(false);
  //       if (res.status && parseInt(res.status) > 200) throw new Error();

  //       setShow(false);
  //       console.log("CreditoTrabalhador - handleSimulation - res: ", res);
  //       props.alterarProposta(res.data);
  //       props.alterarCliente(res.data.cliente_id);
  //       // props.setClienteDados(res.data);

  //       if (props.toggleStep) props.toggleStep(1);
  //     })
  //     .catch((e) => {
  //       console.log("CreditoTrabalhador.index - Erro ao gravar proposta: ", e);
  //       setGravando(false);
  //     });
  // };
  const consultarVinculos = async (_proposta) => {
    console.log("CreditoTrabalhador.consultarVinculos");
    setGravando(true);
    setLegendaGravando("Consultando vínculos...");

    // Consultar vínculos
    await sendData({
      uri: uriList("consultarVinculosCTrab"),
      content: {
        cpf: dados.cpf.replace(/\D/g, ''),
        proposta_uuid: _proposta.uuid || _proposta.proposta_uuid,
        contaSelecionada,
        vinculoSelecionado,
      },
      method: "POST",
    })
      .then((vinculos) => {
        console.log("CreditoTrabalhador.avancar - vinculos: ", vinculos);
        if (vinculos?.status && parseInt(vinculos?.status) > 200) throw new Error();

        setGravando(false);
        setLegendaGravando("");

        // Filtrar apenas vínculos elegíveis
        const vinculosElegiveis = (vinculos?.data?.vinculos || []).filter(
          (v) => v.elegivelEmprestimo === true
        );

        if (vinculosElegiveis?.length === 0) {
          swalError({
            title: "Atenção",
            text: "Nenhum vínculo elegível encontrado para este CPF.",
          });
        }
        else
          setVinculos(vinculosElegiveis);
      })
      .catch((e) => {
        console.log("CreditoTrabalhador.avancar(erro-vinculos) ", e);
        setGravando(false);
        setLegendaGravando("");
        swalError({
          title: "Erro",
          text: "Erro ao consultar vínculos. Tente novamente.",
        });
      });
  }

  const avancar = async () => {
    console.log("CreditoTrabalhador.consultar");
    if (!validarDados()) return;

    setGravando(true);
    setLegendaGravando("Gravando proposta...");
    dados.agente_id =
      ["AGENTE", "OPERADOR PARCEIRO"].indexOf(props.user?.tipo) >= 0
        ? props.user?.pessoa_id
        : null;
    dados.operador_id = props.user?.pessoa_id;

    await sendData({
      uri: uriList("gravarPropostaCTrab"),
      content: {
        dados,
        contaSelecionada,
        vinculoSelecionado,
      },
      method: "POST",
    })
      .then(async (res) => {
        console.log("CreditoTrabalhador.avancar - res: ", res);
        if (res.status && parseInt(res.status) > 200)
          throw new Error(res.message || res.erro || "Erro ao gravar proposta. Tente novamente.");

        // Setar cliente e proposta no Redux
        const _proposta = res.data
        props.setClienteDados(_proposta);
        setProposta(_proposta);

        consultarVinculos(_proposta);
      })
      .catch((e) => {
        console.log("CreditoTrabalhador.avancar - Erro ao gravar proposta: ", e);
        setGravando(false);
        setLegendaGravando("");
        swalError({
          title: "Erro ao gravar proposta",
          text: e.message || "Erro ao gravar proposta. Tente novamente.",
        });
      });
  };

  const handleSelectVinculo = (identificador) => {
    // Toggle: se já está selecionado, desmarca; senão, seleciona
    setVinculoSelecionado(vinculoSelecionado === identificador ? null : identificador);
  };

  const handleSelectConta = (idConta) => {
    // Toggle: se já está selecionado, desmarca; senão, seleciona
    setContaSelecionada(contaSelecionada === idConta ? null : idConta);
  };

  const voltarParaVinculos = () => {
    console.log("CreditoTrabalhador.voltarParaVinculos - Voltando para seleção de vínculos");
    // Limpar apenas as contas e a conta selecionada
    // Mantém vínculos, vínculo selecionado e avaliação de risco
    setContas(null);
    setContaSelecionada(null);
  };

  const consultarParametrosVinculoCTrab = async () => {
    console.log("CreditoTrabalhador.consultarParametrosVinculoCTrab");

    let result = false;
    const _vinculo = vinculos.find(v => v.identificador === vinculoSelecionado);
    await sendData({
      uri: uriList("consultarParametrosVinculoCTrab"),
      content: {
        cpf: dados.cpf.replace(/\D/g, ''),
        idVinculo: vinculoSelecionado,
        vinculo: _vinculo,
        vinculoSelecionado,
        contaSelecionada,
        proposta_uuid: proposta.uuid || proposta.proposta_uuid
      },
      method: "POST",
    })
      .then((res) => {
        console.log("CreditoTrabalhador.consultarParametrosVinculoCTrab - res: ", res);
        if (res?.status && parseInt(res?.status) > 200) throw new Error();

        result = true;
        setParametrosVinculo(res.data);
      })
      .catch((e) => {
        console.log("CreditoTrabalhador.consultarParametrosVinculoCTrab - erro: ", e);
        result = false;
        swalError({
          title: "Erro",
          text: "Erro ao gravar parâmetros do vinculo. Tente novamente.",
        });
      });
    return result;
  }

  const confirmarVinculo = async () => {
    console.log("CreditoTrabalhador.confirmarVinculo", vinculoSelecionado);
    if (!vinculoSelecionado) return;

    setGravando(true);
    setLegendaGravando("Gravando parâmetros do vínculo...");

    //-- Consultar parâmetros do vinculo
    const _parametroVinculo = await consultarParametrosVinculoCTrab();
    if (!_parametroVinculo) {
      setGravando(false);
      setLegendaGravando("");
      swalError({
        title: "Erro",
        text: "Erro ao consultar parâmetros do vinculo. Tente novamente.",
      });
      return;
    }

    setLegendaGravando("Consultando contas...");
    const _vinculo = vinculos.find(v => v.identificador === vinculoSelecionado);
    await sendData({
      uri: uriList("consultarContasCtrab"),
      content: {
        cpf: dados.cpf.replace(/\D/g, ''),
        idVinculo: vinculoSelecionado,
        vinculo: _vinculo,
        vinculoSelecionado,
        proposta_uuid: proposta.uuid || proposta.proposta_uuid
      },
      method: "POST",
    })
      .then((res) => {
        console.log("CreditoTrabalhador.consultarContasCtrab - res: ", res);
        if (res?.status && parseInt(res?.status) > 200) throw new Error();

        setGravando(false);
        setLegendaGravando("");
        setContas(res.data)

        // // Atualizar Redux com os dados completos
        // props.alterarProposta(proposta);
        // props.alterarCliente(proposta.cliente_id);

        // // Avançar para próxima etapa se houver
        // if (props.toggleStep) props.toggleStep(1);
      })
      .catch((e) => {
        console.log("CreditoTrabalhador.consultarContasCtrab - erro: ", e);
        setGravando(false);
        setLegendaGravando("");
        swalError({
          title: "Erro",
          text: "Erro ao consultar contas. Tente novamente.",
        });
      });
  };

  const atualizarContaVinculoNoBackend = async () => {
    const conta = contas.find(c => c.idConta === contaSelecionada);
    const vinculo = vinculos.find(v => v.identificador === vinculoSelecionado);

    console.log("CreditoTrabalhador.atualizarContaVinculoNoBackend - Atualizando conta/vínculo no backend sem refazer avaliação");

    setGravando(true);
    setLegendaGravando("Atualizando informações...");

    try {
      // Usa a mesma URI de consultar contas, mas o backend deve identificar
      // que é uma atualização quando já existe avaliação de risco
      await sendData({
        uri: uriList("consultarContasCtrab"),
        content: {
          cpf: dados.cpf.replace(/\D/g, ''),
          conta,
          vinculo,
          contaSelecionada,
          vinculoSelecionado,
          proposta_uuid: proposta.uuid || proposta.proposta_uuid,
          apenasAtualizar: true // Flag para indicar que é apenas atualização
        },
        method: "POST",
      });

      console.log("CreditoTrabalhador.atualizarContaVinculoNoBackend - Informações atualizadas com sucesso");
      setGravando(false);
      setLegendaGravando("");
      return true;
    } catch (e) {
      console.log("CreditoTrabalhador.atualizarContaVinculoNoBackend - Aviso: erro ao atualizar (continuando):", e);
      setGravando(false);
      setLegendaGravando("");
      // Não mostra erro, apenas loga - a simulação pode continuar
      return true;
    }
  };

  const confirmarConta = async () => {
    console.log("CreditoTrabalhador.confirmarConta", contaSelecionada);
    if (!contaSelecionada) return;

    // Verificar se já tem limites (avaliação já concluída)
    if (limites) {
      console.log("CreditoTrabalhador.confirmarConta - Limites já disponíveis, atualizando conta e abrindo simulação");
      await atualizarContaVinculoNoBackend();
      setShow(true);
      return;
    }

    // Verificar se já tem avaliação de risco em andamento/concluída
    if (avaliacaoDeRisco?.response) {
      console.log("CreditoTrabalhador.confirmarConta - Avaliação já existe");

      // Se já tem limites salvos, atualizar conta e abrir simulação
      if (avaliacaoDeRisco.response.limites) {
        console.log("CreditoTrabalhador.confirmarConta - Avaliação tem limites, atualizando conta e abrindo simulação");
        setLimites(avaliacaoDeRisco.response.limites);
        await atualizarContaVinculoNoBackend();
        setShow(true);
        return;
      }

      // Se tem idSolicitacao mas não tem limites ainda, atualizar conta e consultar status
      if (avaliacaoDeRisco.response.idSolicitacao) {
        console.log("CreditoTrabalhador.confirmarConta - Avaliação em andamento, atualizando conta e consultando status");
        await atualizarContaVinculoNoBackend();
        setAguardandoAvaliacao(true);
        consultarAvaliacaoRiscoCTrab();
        return;
      }
    }

    // Se não tem avaliação, solicitar nova
    const conta = contas.find(c => c.idConta === contaSelecionada);
    const vinculo = vinculos.find(v => v.identificador === vinculoSelecionado);
    setGravando(true);
    setLegendaGravando("Solicitando avaliação de risco...");

    await sendData({
      uri: uriList("solicitarAvaliacaoRiscoCTrab"),
      content: {
        cpf: dados.cpf.replace(/\D/g, ''),
        conta,
        vinculo,
        contaSelecionada,
        vinculoSelecionado,
        proposta_uuid: proposta.uuid || proposta.proposta_uuid
      },
      method: "POST",
    })
      .then((res) => {
        console.log("CreditoTrabalhador.confirmarConta - res: ", res);
        if (res?.status && parseInt(res?.status) > 200) throw new Error();

        setGravando(false);
        setLegendaGravando("");

        // Ativar o banner de aguardando avaliação
        setAguardandoAvaliacao(true);
        setAvaliacaoDeRisco(res.data)
      })
      .catch((e) => {
        console.log("CreditoTrabalhador.confirmarConta - erro: ", e);
        setGravando(false);
        setLegendaGravando("");
        swalError({
          title: "Erro",
          text: "Erro ao solicitar avaliação de risco. Tente novamente.",
        });
      });
  };

  const simularContratoCTrab = async (dadosSimulacao) => {
    console.log("CreditoTrabalhador.simularContratoCTrab", dadosSimulacao);
    setGravando(true);
    setLegendaGravando("Realizando simulação...");

    await sendData({
      uri: uriList("simularContratoCTrab"),
      content: {
        cpf: dados.cpf.replace(/\D/g, ''),
        proposta_uuid: proposta.uuid || proposta.proposta_uuid,
        simulacao: dadosSimulacao,
        contaSelecionada,
        vinculoSelecionado,
        avaliacaoDeRisco
      },
      method: "POST",
    })
      .then((res) => {
        console.log("CreditoTrabalhador.simularContratoCTrab - res: ", res);
        if (res?.status && parseInt(res?.status) > 200) throw new Error();

        setGravando(false);
        setLegendaGravando("");
        setShow(false);
        setSimulacaoCTrab(res.data);
        console.log("CreditoTrabalhador.simularContratoCTrab - simulacaoCTrab: ", res.data);

        // // Atualizar proposta se necessário
        // if (res?.data?.proposta) {
        //   props.alterarProposta(res.data.proposta);
        // }

        // swalError({
        //   title: "Sucesso",
        //   text: "Simulação realizada com sucesso!",
        // });

        // // Avançar para próxima etapa se houver
        // if (props.toggleStep) props.toggleStep(1);
      })
      .catch((e) => {
        console.log("CreditoTrabalhador.simularContratoCTrab - erro: ", e);
        setGravando(false);
        setLegendaGravando("");
        swalError({
          title: "Erro",
          text: "Erro ao realizar simulação. Tente novamente.",
        });
      });
  };

  const formatCNPJ = (numero) => {
    if (!numero) return "";
    const str = String(numero).padStart(14, "0");
    return str.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
  };

  const getTipoConta = (tipo) => {
    switch (tipo) {
      case 0:
        return "Corrente";
      case 1:
        return "Poupança";
      case 2:
        return "Salário";
      default:
        return "Não identificado";
    }
  };

  const formatIdConta = (idConta) => {
    if (!idConta) return "";
    const id = String(idConta);
    if (id.length <= 16) return id;

    const parts = id.split("-");
    if (parts.length >= 2) {
      return `${parts[0]}...${parts[parts.length - 1]}`;
    }

    return `${id.substring(0, 8)}...${id.substring(id.length - 8)}`;
  };

  const handleFecharResumo = () => {
    // Voltar para a tela de simulação
    setSimulacaoCTrab(null);
    setShow(true);
  };

  const acompanharProposta = async () => {
    sendData({
      uri: uriList("acompanharProposta"),
      content: {
        uuid: proposta.uuid || proposta.proposta_uuid,
        contaSelecionada,
        vinculoSelecionado,
      },
      method: "POST",
    })
      .then((res) => {
        // let _dados = { ...result, ...userData, ...res }
        let _dados = res
        props.alterarProposta(_dados);
        props.alterarCliente(_dados?.cliente_id);
        setProposta(_dados);
        console.log("result.acompanharProposta(Alterar Proposta): ", _dados);
      })
      .catch((e) => { });
  };

  const confirmarSimulacaoCTrab = async () => {
    console.log("CreditoTrabalhador.confirmarSimulacaoCTrab(Confirmar Simulação): ", simulacaoCTrab);
    sendData({
      uri: uriList("confirmarSimulacaoCTrab"),
      content: {
        uuid: proposta.uuid || proposta.proposta_uuid,
        contaSelecionada,
        vinculoSelecionado,
        simulacao: simulacaoCTrab,
      },
      method: "POST",
    })
      .then((res) => {
        console.log("result.confirmarSimulacaoCTrab(Confirmar Simulação): ", res);
      })
      .catch((e) => { });
  };

  const handleConfirmarSimulacao = async () => {
    // Aqui você pode adicionar a lógica para confirmar a simulação
    // Por exemplo, gravar a simulação escolhida, avançar para próxima etapa, etc.
    console.log("Simulação confirmada:", simulacaoCTrab);
    await acompanharProposta();
    await confirmarSimulacaoCTrab();

    //-- Atribuindo proposta, cliente e sessao
    setSession({ obj: simulacaoCTrab, key: "status" });

    // // Fechar o resumo
    // setSimulacaoCTrab(null);

    // Avançar para próxima etapa se houver
    if (props.toggleStep) props.toggleStep(1, proposta);
  };

  return (
    <>
      {show && (
        <Simulacao
          limites={limites}
          onCloseEv={() => setShow(false)}
          simularContratoCTrab={simularContratoCTrab}
        />
      )}
      {simulacaoCTrab && (
        <ResumoSimulacao
          simulacao={simulacaoCTrab}
          onClose={handleFecharResumo}
          onConfirmar={handleConfirmarSimulacao}
        />
      )}
      <fieldset className="col-12" style={{ height: "100%" }}>
        <h4
          className="text-center font-weight-bold"
          style={{ marginBottom: "15px", marginTop: "10px", color: "#3E6C84", fontSize: "1.75rem" }}
        >
          Crédito Trabalhador
        </h4>

        {/* Banner de Aguardando Avaliação de Risco */}
        {aguardandoAvaliacao && !show && !simulacaoCTrab && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9999
            }}
          >
            <div
              className="alert alert-info"
              style={{
                maxWidth: "600px",
                width: "90%",
                padding: "30px",
                backgroundColor: "#d1ecf1",
                borderColor: "#bee5eb",
                borderRadius: "12px",
                boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
                margin: 0
              }}
            >
              <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <Spinner
                  animation="border"
                  style={{ width: "50px", height: "50px", color: "#0c5460", marginBottom: "15px" }}
                />
                <h4 style={{ color: "#0c5460", fontWeight: "bold", marginBottom: "10px" }}>
                  Aguardando Avaliação de Risco
                </h4>
                <p style={{ marginBottom: "20px", color: "#0c5460", fontSize: "1rem" }}>
                  A avaliação de risco foi solicitada. O sistema está consultando automaticamente o status a cada 20 segundos.
                </p>
              </div>
              <div style={{ textAlign: "center" }}>
                <Button
                  color="info"
                  onClick={() => {
                    consultarAvaliacaoRiscoCTrab();
                  }}
                  style={{
                    backgroundColor: "#17a2b8",
                    borderColor: "#17a2b8",
                    fontWeight: "bold",
                    padding: "10px 30px",
                    fontSize: "1rem"
                  }}
                >
                  Consultar Agora
                </Button>
              </div>
            </div>
          </div>
        )}

        {(!vinculos || vinculos?.length === 0) && !show && !simulacaoCTrab && (
          <div className="form" style={{ width: "100%", padding: "0 15px" }}>
            <div className="row ">
              <div className="form-group col-md-4">
                <InputLabelAlert
                  type="tel"
                  label="CPF"
                  id="cpf"
                  name="cpf"
                  value={dados.cpf}
                  handle={handleCpf}
                  autoComplete="off"
                  length="14"
                  focus={true}
                  autoFocus={true}
                  required
                  onContextMenu={(e) => e.preventDefault()}
                />
                <InputAlert display={warning.cpf} messages={"CPF inválido."} />
              </div>
              <div className="form-group col-md-8">
                <InputLabelAlert
                  type="text"
                  label="Nome"
                  id="nome"
                  name="nome"
                  value={dados.nome}
                  handle={handleChange}
                  autoComplete="off"
                  required
                  onContextMenu={(e) => e.preventDefault()}
                  disabled={clienteExistente}
                />
              </div>
              <div className="form-group col-md-3">
                <InputLabelAlert
                  type="tel"
                  label="Data de Nascimento"
                  id="ddn"
                  name="ddn"
                  value={dados.ddn}
                  handle={handleChange}
                  onBlur={handleBlur}
                  warning={warning.ddn}
                  length="10"
                  required
                  disabled={clienteExistente}
                  focus={false}
                />
                <InputAlert
                  display={warning.ddn}
                  messages={"Data de nascimento inválida."}
                />
              </div>
              <div className="form-group col-md-3">
                <InputLabelAlert
                  type="tel"
                  label="Telefone"
                  id="telefone"
                  name="telefone"
                  warning={warning.telefone}
                  value={dados.telefone}
                  handle={handleChange}
                  onBlur={handleBlur}
                  length="15"
                  required
                  focus={false}
                />
                <InputAlert
                  display={warning.telefone}
                  messages={"Telefone inválido."}
                />
              </div>
              <div className="form-group col-md-6">
                <InputLabelAlert
                  type="email"
                  id="email"
                  name="email"
                  label="E-mail"
                  minLength={5}
                  value={dados.email}
                  warning={warning.email}
                  handle={handleChange}
                  onBlur={handleBlur}
                  lowercase={true}
                  focus={false}
                />
                <InputAlert
                  display={warning.email}
                  messages={"E-mail inválido."}
                />
              </div>
            </div>

            <div className="row form-group mt-5 d-flex justify-content-center">
              <button
                style={{ backgroundColor: "#3E6C84", width: "30%" }}
                onClick={props.reRender}
                className="btn btn-md btn-info font-weight-bold mr-2"
              >
                Limpar
              </button>

              <button
                style={{ backgroundColor: "#3E6C84", width: "30%" }}
                onClick={avancar}
                className="btn btn-md btn-info font-weight-bold mr-2"
                disabled={vinculos && vinculos?.length > 0}
              >
                Avançar
              </button>
            </div>
          </div>
        )}

        {vinculos && vinculos.length > 0 && !contas && !show && !simulacaoCTrab && (
          <div className="form" style={{ width: "100%", padding: "0 15px" }}>
            <div className="row mt-2">
              <div className="col-12">
                <div
                  style={{
                    border: "2px solid #3E6C84",
                    borderRadius: "10px",
                    padding: "10px",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <h5
                    className="font-weight-bold"
                    style={{ color: "#3E6C84", marginBottom: "10px", fontSize: "1.1rem" }}
                  >
                    Vínculos Disponíveis
                  </h5>
                  <div
                    style={{
                      maxHeight: "calc(100vh - 280px)",
                      overflowY: "auto",
                      overflowX: "hidden",
                      border: "1px solid #dee2e6",
                      borderRadius: "5px"
                    }}
                  >
                    <table className="table table-bordered table-hover" style={{ marginBottom: 0 }}>
                      <thead style={{ backgroundColor: "#3E6C84", color: "#fff", position: "sticky", top: 0, zIndex: 10 }}>
                        <tr>
                          <th style={{ width: "50px", textAlign: "center", padding: "6px" }}>
                            Selecionar
                          </th>
                          <th style={{ padding: "6px" }}>Identificador</th>
                          <th style={{ padding: "6px" }}>Empregador (CNPJ)</th>
                          <th style={{ padding: "6px" }}>Convênio</th>
                        </tr>
                      </thead>
                      <tbody>
                        {vinculos.map((vinculo, index) => (
                          <tr key={index}>
                            <td style={{ textAlign: "center", verticalAlign: "middle", padding: "6px" }}>
                              <input
                                type="checkbox"
                                checked={vinculoSelecionado === vinculo.identificador}
                                onChange={() =>
                                  handleSelectVinculo(vinculo?.identificador)
                                }
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  cursor: "pointer",
                                }}
                              />
                            </td>
                            <td style={{ verticalAlign: "middle", padding: "6px" }}>
                              {vinculo.identificador}
                            </td>
                            <td style={{ verticalAlign: "middle", padding: "6px" }}>
                              {formatCNPJ(vinculo?.empregador?.numeroInscricaoEmpregador)}
                            </td>
                            <td style={{ verticalAlign: "middle", padding: "6px" }}>
                              {vinculo?.convenio?.nome}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-center mt-2">
                    <button
                      style={{ backgroundColor: "#3E6C84", width: "30%", padding: "8px" }}
                      onClick={confirmarVinculo}
                      className="btn btn-sm btn-info font-weight-bold"
                      disabled={!vinculoSelecionado}
                    >
                      Confirmar Vínculo
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Tabela de Contas */}
        {contas && contas.length > 0 && !aguardandoAvaliacao && !show && !simulacaoCTrab && (
          <div className="form" style={{ width: "100%", padding: "0 15px" }}>
            <div className="row mt-2">
              <div className="col-12">
                <div
                  style={{
                    border: "2px solid #3E6C84",
                    borderRadius: "10px",
                    padding: "10px",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <h5
                    className="font-weight-bold"
                    style={{ color: "#3E6C84", marginBottom: "10px", fontSize: "1.1rem" }}
                  >
                    Contas Disponíveis
                  </h5>
                  <div
                    style={{
                      maxHeight: "calc(100vh - 280px)",
                      overflowY: "auto",
                      overflowX: "hidden",
                      border: "1px solid #dee2e6",
                      borderRadius: "5px"
                    }}
                  >
                    <table className="table table-bordered table-hover" style={{ marginBottom: 0 }}>
                      <thead style={{ backgroundColor: "#3E6C84", color: "#fff", position: "sticky", top: 0, zIndex: 10 }}>
                        <tr>
                          <th style={{ width: "50px", textAlign: "center", padding: "6px" }}>
                            Selecionar
                          </th>
                          <th style={{ padding: "6px" }}>ID</th>
                          <th style={{ padding: "6px" }}>Número</th>
                          <th style={{ padding: "6px" }}>Unidade</th>
                          <th style={{ padding: "6px" }}>Produto</th>
                          <th style={{ padding: "6px" }}>Tipo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {contas.map((conta, index) => (
                          <tr key={index}>
                            <td style={{ textAlign: "center", verticalAlign: "middle", padding: "6px" }}>
                              <input
                                type="checkbox"
                                checked={contaSelecionada === conta.idConta}
                                onChange={() =>
                                  handleSelectConta(conta?.idConta)
                                }
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  cursor: "pointer",
                                }}
                              />
                            </td>
                            <td
                              style={{ verticalAlign: "middle", padding: "6px", cursor: "help" }}
                              title={conta.idConta}
                            >
                              {formatIdConta(conta.idConta)}
                            </td>
                            <td style={{ verticalAlign: "middle", padding: "6px" }}>
                              {conta.numero}
                            </td>
                            <td style={{ verticalAlign: "middle", padding: "6px" }}>
                              {conta.unidade}
                            </td>
                            <td style={{ verticalAlign: "middle", padding: "6px" }}>
                              {conta.produto}
                            </td>
                            <td style={{ verticalAlign: "middle", padding: "6px" }}>
                              {getTipoConta(conta.tipo_conta)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </div>
            <div className="d-flex justify-content-center mt-2" style={{ gap: "10px" }}>
              <button
                style={{ backgroundColor: "#6c757d", width: "30%", padding: "8px" }}
                onClick={voltarParaVinculos}
                className="btn btn-sm btn-secondary font-weight-bold"
              >
                Voltar
              </button>
              <button
                style={{ backgroundColor: "#3E6C84", width: "30%", padding: "8px" }}
                onClick={confirmarConta}
                className="btn btn-sm btn-info font-weight-bold"
                disabled={!contaSelecionada}
              >
                Confirmar Conta
              </button>
            </div>
          </div>
        )}
      </fieldset>
      {consultando && <Aguarde />}
      {gravando && <Aguarde legenda={legendaGravando || "Aguarde..."} />}
    </>
  );
}

function mapStateToProps(state) {
  return {
    user: state.dados.user,
    proposta: state.dados.proposta,
    detalhes: state.dados.detalhes,
    clienteDados: state.dados.clienteDados,
  };
}

function mapActionToProps(dispatch) {
  return {
    alterarCliente(novoCliente) {
      dispatch(setCliente(novoCliente));
    },
    setAlterarProposta(alterar, proposta) {
      dispatch(setAlterarProposta(alterar, proposta));
    },
    alterarProposta(novaProposta) {
      dispatch(setProposta(novaProposta));
    },
    setClienteDados(novoCliente) {
      dispatch(setClienteDados(novoCliente));
    },
  };
}

export default connect(mapStateToProps, mapActionToProps)(CreditoTrabalhador);
